import React from 'react'
import { FormControl, TextField, Grid, Button, Chip } from '@mui/material';

export const FormPermission = ({ useFetchInit, dataModal }) => {

    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormPermissions, FormPermissionsChild } = Forms
    const { formState, onInputChange } = FormPermissions
    const { formState: formStateChild, onInputChange: onInputChangeChild } = FormPermissionsChild
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const {
        onSubmitFormPermissions,
        handleClickEnableData,
        handleClickDisableData
    } = Actions

    const { dataRequest } = dataModal
    return (
        <div className='container'>
            <div className="pt-4"></div>
            <div className="text-dark"> * Información del permiso </div>
            <div className="border-bottom border-dark"></div>
            <div className="pt-4"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={6} md={8} lg={8}>
                    <FormControl fullWidth>
                        <TextField
                            id="nombrepermisos"
                            name="nombrepermisos"
                            value={formState.nombrepermisos}
                            onChange={onInputChange}
                            label="Nombre permiso"
                            size="small"
                            type="text"
                            InputProps={{ readOnly: false }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4}>
                    <Grid container spacing={2} justifyContent="flex-start">
                        <Grid item>
                            <Button
                                style={{background: "#94521c"}}
                                variant="contained"
                                type="button"
                                onClick={(e) => onSubmitFormPermissions(e, 'PADRE')}
                            >
                                GUARDAR
                            </Button>
                        </Grid>
                        {(formState.idpermiso !== '' && formState.estado === 1)&&(
                            <Grid item>
                                <Button
                                    color="error"
                                    variant="contained"
                                    type="button"
                                    onClick={(e) => handleClickDisableData(formState.idpermiso)}
                                >
                                    DESACTIVAR
                                </Button>
                            </Grid>
                        )}
                        {(formState.idpermiso !== '' && (formState.estado === 0 || !formState.estado))&&(
                            <Grid item>
                                <Button
                                    style={{background: "#539424"}}
                                    variant="contained"
                                    type="button"
                                    onClick={(e) => handleClickEnableData(formState.idpermiso)}
                                >
                                    ACTIVAR
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <div className="pt-4"></div>
            {formState.tag && (
                <Chip
                    label={`TAG: ${formState.tag}`}
                    size="small"
                    variant="outlined"
                    sx={{
                        maxWidth: '100%',
                        height: 'auto',
                        bgcolor: 'grey.50',
                        borderColor: 'grey.300',
                        color: 'text.secondary',
                        borderRadius: 1.5,
                        '& .MuiChip-label': {
                            py: 0.5,
                            px: 1.25,
                            fontFamily: 'monospace',
                            fontSize: '0.75rem',
                            fontWeight: 500,
                            whiteSpace: 'normal',
                            overflowWrap: 'anywhere',
                            userSelect: 'text',
                        },
                    }}
                />
            )}
            {(dataRequest.data.idpermiso !== '' && dataRequest.data.nivel < 3 ) && (
                <>
                    <div className="pt-4"></div>
                    <div className="text-danger"> * Crear permiso hijo </div>
                    <div className="border-bottom border-danger"></div>
                    <div className="pt-4"></div>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={8} lg={8}>
                            <FormControl fullWidth>
                                <TextField
                                    id="nombrepermisos"
                                    name="nombrepermisos"
                                    value={formStateChild.nombrepermisos}
                                    onChange={onInputChangeChild}
                                    label="Nombre permiso hijo"
                                    size="small"
                                    type="text"
                                    InputProps={{ readOnly: false }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <FormControl fullWidth>
                                <Button
                                    style={{background: "#4b4b4c"}}
                                    variant="contained"
                                    type="button"
                                    onClick={(e) => onSubmitFormPermissions(e, 'HIJO')}
                                >
                                    CREAR HIJO
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </>
            )}
            <div className="pt-4"></div>
        </div>
    )
}
